import { render } from "./NoDataAnim.vue?vue&type=template&id=281dc2fa&scoped=true"
import script from "./NoDataAnim.vue?vue&type=script&lang=js"
export * from "./NoDataAnim.vue?vue&type=script&lang=js"

import "./NoDataAnim.vue?vue&type=style&index=0&id=281dc2fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281dc2fa"]])

export default __exports__